// The section MLI job omits OPEN_TEXT (T-type) questions, so they never reach
// the survey detail page on their own. The survey structure does include them,
// in the section's canonical question order. Walk that order, preferring the
// job's version of a question (it carries queryResult) and falling back to the
// structure's version for OPEN_TEXT questions the job left out. Only standalone
// T-type questions (the ones with their own code from the variable listing) are
// pulled in — the codeless "(open responses)" companions of other questions stay
// hidden.
const mergeOpenTextQuestions = (jobQuestions, sectionQuestions) => {
  if (!sectionQuestions?.length) return jobQuestions;
  const jobById = new Map(jobQuestions.map((question) => [question.id, question]));
  const merged = [];
  sectionQuestions.forEach((question) => {
    const jobQuestion = jobById.get(question.id);
    if (jobQuestion) {
      merged.push(jobQuestion);
      jobById.delete(question.id);
    } else if (question.questionType === 'OPEN_TEXT' && question.code) {
      merged.push(question);
    }
  });
  // keep any job questions the structure doesn't know about
  jobById.forEach((question) => merged.push(question));
  return merged;
};

export default mergeOpenTextQuestions;
